var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5517 6.33527L8.13395 11.6053C7.28499 12.6181 5.77707 12.7507 4.7643 11.9018C3.75154 11.0528 3.61887 9.54488 4.46784 8.53212L9.2697 2.80381C9.79982 2.17141 10.7433 2.0884 11.3757 2.61852C12.0081 3.14865 12.0911 4.09215 11.561 4.72455L7.52746 9.53633C7.31618 9.78838 6.93709 9.82173 6.68505 9.61045C6.433 9.39916 6.39965 9.02008 6.61093 8.76803L10.2603 4.41452L9.57295 3.8383L5.92353 8.19181C5.39341 8.82421 5.47642 9.76772 6.10882 10.2978C6.74123 10.828 7.68473 10.745 8.21486 10.1126L12.2484 5.30078C13.0974 4.28801 12.9647 2.78009 11.952 1.93113C10.9392 1.08216 9.43127 1.21482 8.5823 2.22759L3.78044 7.95589C2.61263 9.34902 2.79496 11.4214 4.18808 12.5892C5.5812 13.757 7.65354 13.5747 8.82135 12.1815L13.2391 6.91149L12.5517 6.33527Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.6c89972ed131ff63827256016aa0e37b.svg";
export { ForwardRef as ReactComponent };